import { css, styled } from 'styled-components';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { brandingColourHeavy, whiteColour } from '../../cssConstants';
import ExternalLink from '../../common/ExternalLink';

export const LinkButton = ({ href, to, state, children, className }: LinkButtonProps) => {
	if (to) {
		return (
			<StyledLink to={to} state={state} className={className}>
				{children}
			</StyledLink>
		);
	}
	if (href.startsWith('http')) {
		return <BlueButtonExternalLink href={href}>{children}</BlueButtonExternalLink>;
	}
	return <BlueButtonAnchorLink href={href}>{children}</BlueButtonAnchorLink>;
};

interface LinkButtonProps {
	href?: string;
	to?: string;
	state?: unknown;
	children?: React.ReactNode;
	className?: string;
}

const buttonStyles = css`
	text-decoration: none;
	background: ${({ theme }) => theme.primaryBackground};
	border-radius: 50px;
	border: none;
	color: ${whiteColour};
	font-size: 14px;
	width: 237px;
	min-height: 44px;
	max-height: 44px;
	padding: 10px;
	align-items: center;
	gap: 8px;
	margin: auto;
	text-align: center;
	display: flex;
	justify-content: center;
`;

export const StyledLink = styled(Link)`
	${buttonStyles};
`;

export const ActionButton = styled.button`
	${buttonStyles};
	cursor: pointer;
`;

const BlueButtonAnchorLink = styled.a`
	${buttonStyles};
`;

export const BlueButtonExternalLink = styled(ExternalLink)`
	${buttonStyles};
`;

export const WhiteButtonExternalLink = styled(ExternalLink)`
	${buttonStyles};
	background: ${whiteColour};
	color: ${brandingColourHeavy};
	line-height: 20px;
	font-weight: 500;
`;
